module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-editorial-hero-67e52d90262b3069f52237f778a8a905.png";